import Swiper, { Manipulation, Navigation, Thumbs, Lazy, Pagination, Autoplay } from 'swiper';
import {fadeOutEffect, fadeInEffect, slideUp, slideDown, simulateClick} from './serie-effects.js';

Swiper.use([Manipulation, Navigation, Thumbs, Lazy, Pagination, Autoplay]);

let product = document.querySelector('.page__product');
let isMobile = false;

if(window.screen.width >= 1023){
    isMobile = false;
} else {
    isMobile = true;
}

const productFunctions = {
    thumbnail: function(){
        const productsCarousel = product.querySelectorAll('[data-slider-thumbs]');
    
        if(productsCarousel){
            productsCarousel.forEach((section) => {
                const carousel = section.querySelector('.swiper');
                const pagination = section.querySelector('.swiper-thumb-pagination');
            
                if (carousel) {
                    new Swiper(carousel, {
                        slidesPerView: 1,
                        preloadImages: false,
                        loop: false,
                        lazy: {
                          checkInView: true,
                          loadPrevNext: false,
                          loadOnTransitionStart: true,
                        },
                        pagination: {
                            el: pagination,
                            type: 'bullets',
                            clickable: true,
                        },
                    });
                }
            });
        }
    },

    discountPrice: function(){
        window.addEventListener('load', () => {
            setTimeout(() => {
                let price = product.querySelector('.product__details .price-wrapper .cmp-price-sale-price');
                let priceOffer = product.querySelector('.product__details .price-wrapper .cmp-price-original-price');
    
                if( priceOffer != null ){
                    price = parseFloat( price.textContent.split('R$ ')[1].replace(".", "").replace(",", ".") );;
                    priceOffer = parseFloat( priceOffer.textContent.split('R$ ')[1].replace(".", "").replace(",", ".") );;
                    let discountOffer = 100 - (  price / priceOffer ) * 100;
                    discountOffer = discountOffer.toFixed(0);
    
                    let discountOfferNode =  `<div class="flag discount"><span>${discountOffer}%</span></div>`;
    
                    product.querySelector('.product__details .details__flags').insertAdjacentHTML('afterbegin', discountOfferNode);
                }
            }, 1000);
        });
    },

    descriptionTabs: function(){
        let tabs = Array.from( product.querySelectorAll('.descriptions__tabs .tabs__wrapper') );

        if( tabs.length > 0 ){
            tabs.forEach(tab => {
                tab.querySelector('.tabs__wrapper .tabs__title').addEventListener('click', (event) => {
                    let _this = event.currentTarget;
                    let counter = 0;

                    if( _this.classList.contains('active') ){
                        slideUp( tab.querySelector('.tabs__content') );

                        _this.classList.remove('active');

                    } else {
                        tabs.forEach(tabOuter => {
                            slideUp( tabOuter.querySelector('.tabs__content') );

                            tabOuter.querySelector('.tabs__wrapper .tabs__title').classList.remove('active');

                            counter++;

                            if( counter === tabs.length ){
                                setTimeout(() => {
                                    slideDown( tab.querySelector('.tabs__content') );
                                }, 500);
                            }
                        });

                        _this.classList.add('active');
                    }
                });
            });
        }
    },

    showcaseRelated: function(){
        const productsCarousel = product.querySelectorAll('[data-related-carousel]');
    
        if(productsCarousel){
            productsCarousel.forEach((section) => {
                const carousel = section.querySelector('.swiper');
                const next = section.querySelector('.swiper-button-related-next');
                const prev = section.querySelector('.swiper-button-related-prev');
            
                if (carousel) {
                    new Swiper(carousel, {
                        slidesPerView: 2,
                        preloadImages: false,
                        loop: false,
                        lazy: {
                          checkInView: true,
                          loadPrevNext: false,
                          loadOnTransitionStart: true,
                        },
                        breakpoints: {
                            1475: {
                                slidesPerView: 5,
                            },
                            1024: {
                                slidesPerView: 4,
                            },
                            767: {
                                slidesPerView: 3,
                            }
                        },
                        navigation: {
                            nextEl: next,
                            prevEl: prev,
                        },
                    });
                }
            });
        }
    },

    init: function(){
        const _this = this;

        /*if( isMobile == true ){
            _this.thumbnail();
        }*/

        _this.discountPrice();
        _this.descriptionTabs();
        _this.showcaseRelated();
    },
}

export default productFunctions;